import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Replace these with your actual images (add them to Assets/Projects/)
import playwrightImg from "../../Assets/Projects/test.png";
import restAssuredImg from "../../Assets/Projects/test.png";
import appiumImg from "../../Assets/Projects/test.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Quality Engineering <strong className="purple">Projects</strong>
        </h1>

        <p style={{ color: "white" }}>
          Production-style frameworks focused on determinism, maintainability,
          and CI-ready automation across web, API, and mobile.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {/* Playwright */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={playwrightImg}
              isBlog={false}
              title="Playwright Automation Framework (TypeScript)"
              description="Production-grade Playwright + TypeScript framework designed for a modern SaaS workflow. Includes storageState auth setup, typed fixtures, clean POM boundaries, tagging (@smoke/@regression), CI-friendly retries, and rich artifacts (trace/video/screenshots) for fast debugging."
              ghLink="https://github.com/victorIkeokoro/playwright-tests"
              demoLink="" // optional
            />
          </Col>

          {/* Rest Assured */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={restAssuredImg}
              isBlog={false}
              title="REST Assured API Test Suite (Java)"
              description="API automation suite built with Java + REST Assured for contract and regression testing. Focuses on deterministic assertions, reusable request builders, schema/response validation patterns, and reporting. Designed to support fast feedback in CI and shift-left quality."
              ghLink="https://github.com/victorIkeokoro/Rest-assured-java-project"
              demoLink="" 
            />
          </Col>

          {/* Appium */}

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={appiumImg}
              isBlog={false}
              title="Mobile Automation Framework (Appium)"
              description="Mobile automation framework using Appium with a scalable structure for real-world testing. Includes stable locator strategy, reusable screens/page objects, synchronization patterns to reduce flakiness, and guidance for running locally and in CI with device providers."
              ghLink="https://github.com/victorIkeokoro/Mobile_Automation"
              demoLink="" 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
